import { APIClient } from '@frontend/api-utils';

export class TransactionEnumClient extends APIClient {
    public static readonly endpoint = '/transaction-api/v1';

    public static async fetchTransactionStates(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/transaction-states`);
        return await this.handleResponse<string[]>(response);
    }

    public static async fetchTransactionTriggers(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/transaction-triggers`);
        return await this.handleResponse<string[]>(response);
    }

    public static async fetchTransactionActions(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/transaction-actions`);
        return await this.handleResponse<string[]>(response);
    }
}
